import { authRequest } from './index.js'
import { formatResponse } from '@/utils/errorHandler'

export async function get_roles() {
  try {
    const result = await authRequest.get('/roles')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

export async function get_role(id) {
  try {
    const result = await authRequest.get(`/roles/${id}`)
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

export async function create_role(data) {
  try {
    const result = await authRequest.post('/roles', { role: data })
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

export async function update_role(id, data) {
  try {
    const result = await authRequest.put(`/roles/${id}`, { role: data })
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

export async function delete_role(id) {
  try {
    const result = await authRequest.delete(`/roles/${id}`)
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}
